import { createMigration } from './utils';

export const migrationTo9_207 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene, _isSceneDesign) {
        return scene.withMutations(map => {
            map.get('children', []).forEach((child, i) => {
                if (!child.get('filters')) {
                    return;
                }
                child.get('filters').forEach((filter, f) => {
                    if (filter.get('classType') === 'BlurFilter') {
                        const oldValue = filter.get('blur');
                        map.setIn(['children', i, 'filters', f, 'blur'], oldValue / 10);
                    }
                });
            });
        });
    },
});
